<template>
  <div>
    <div v-if="user.isAgent === '0'" style="background-color: #F6F6F6;padding-bottom: 1.8rem">
      <div class="jinsheng">
        <!--<img style="width: 100%" src="../img/zhaomu.png" alt="">-->
        <div class="guize" @click="guizeFn()">晋升规则</div>
        <img class="img-one" src="../img/hader_top.png" alt />
        <img class="img-two" src="../img/heder_cont.png" alt />
        <img class="img-three" src="../img/header_x3.png" alt />
        <img class="img-btn" @click="joinCommunity" src="../img/btn2.png" alt />
      </div>
      <div class="cont_x cont_x_2">
        <div class="cont_x_fenx">
          <img src="../img/bian.png" alt />
          <h3>70000+合作药店</h3>
        </div>
        <div class="list">
          <div class="contx">
            <img class="mer" src="../img/mer.png" alt />
          </div>
        </div>
      </div>

      <div class="cont_x cont_x2x">
        <div class="cont_x_fenx">
          <img src="../img/bian.png" alt />
          <h3>药联健康套餐</h3>
          <p>每年帮您节省20%购药支出</p>
        </div>
        <div class="list">
          <div class="contx">
            <div
              class="list"
              v-for="(item,i)  in items.slice(0,2)"
              :key="i"
              @click="jumpUrl(item.goodsDetailUrl)"
            >
              <img class="good_list" :src="item.picUrl?item.picUrl:img1" alt />
              <div class="goods_text_cont_x">
                <p class="goods_text_p">{{ item.goodsName }}</p>
                <div class="goods_text_cont">
                  <p class="goods_text goods_text_left">
                    ¥
                    <span>{{ (item.price.split(".")[0]) }}</span>
                    .{{ (item.price.split(".")[1]) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cont_x cont_x2x">
        <div class="cont_x_fenx">
          <img src="../img/bian.png" alt />
          <h3>更多服务</h3>
        </div>
        <div class="list">
          <div class="contx">
            <div class="contx_cont">
              <div class="contx_list_fwu">
                <img src="../img/bei1.png" alt />
                <p>洁牙服务</p>
              </div>

              <div class="contx_list_fwu">
                <img src="../img/bei2.png" alt />
                <p>健康风险保障</p>
              </div>

              <div class="contx_list_fwu">
                <img src="../img/bei3.png" alt />
                <p>全面体检</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="user.isAgent === '1'">
      <div class="youjiang">
        <!--<img style="width: 100%"  src="../img/bg.png" alt="">-->
        <div class="img-box">
          <img class="img-one" src="../img/hader_top.png" alt />
          <img class="img-two" src="../img/x2.png" alt />
          <div class="yaoqing-box">
            <img class="img-three" src="../img/x1.png" alt />
            <div class="yaoqing-txt">
              <div style="display: flex;flex-flow: column;align-items: center">
                <div class="txt">好友出单可获得</div>
                <div class="border"></div>
                <p style="color: #DD2B1E;font-size: 14px">
                  最高
                  <span style="font-size: 36px;margin: 0 5px">30</span>积分
                </p>
                <p style="color: #646464">可购药，可提现</p>
              </div>
              <div style="display: flex;flex-flow: column;align-items: center">
                <div class="txt">你可以获得</div>
                <div class="border"></div>
                <p style="color: #DD2B1E;font-size: 14px">
                  最高
                  <span style="font-size: 36px;margin: 0 5px">5</span>积分
                </p>
                <p style="color: #646464">可购药，可提现</p>
              </div>
            </div>
            <div class="yaoqing-btn" @click="toYindao()" id="yaoqing-btn">
              <img src="../img/yaoqing.png" alt />
            </div>
          </div>
          <img style="width: 6.7rem;margin-bottom: 20px" src="../img/gongliu.png" alt />

          <img style="width: 2.6rem;margin-bottom: 0.16rem" src="../img/x23.png" alt />
          <img style="width: 1.8rem;margin-bottom: 0.16rem;border-radius: 5px" :src="img" alt />
          <img style="width: 2.6rem;margin-bottom: 0.16rem" src="../img/x23.png" alt />
          <p style="color: rgba(255, 255, 255, 0.59);margin-bottom: 0.6rem">扫描或长按识别二维码加入药联健康</p>
          <button
            class="btn"
            @click="toSave()"
            id="btn"
            @touchstart="touchstart()"
            @touchend="touchend()"
          >
           <span style="font-size: 0.32rem;">长按保存图片</span>
            <img class="dataUrl" :src="dataUrl" alt />
          </button>
          <div style="height: 1px"></div>
          <van-popup v-model="imageShow" :style="{ height: '20%'}" position='bottom'>
            <van-button type="default"  @click="saveImage()">保存图片</van-button>
            <van-button type="default" @click="cancelSaveImage()">取消</van-button>
          </van-popup>
        </div>
      </div>
    </div>

    <div class="yingdao" v-if="yindao" @click="yindao = false">
      <img src="../img/fenzhu.png" alt />
    </div>
    <div
      style="background: #fff;position: fixed;width: 100%;height: 100vh;left: 0;top: 0;z-index: -1"
    ></div>
    <div id="bg" ref="saveBox">
      <div>
        <img class="bg_pos" style="width: 100%" src="../img/x121.png" alt />
        <img class="bg_img" :src="img" alt />
      </div>
    </div>
    <van-dialog
      v-model="show"
      @confirm="urlFnT()"
      confirmButtonText="去分享赚钱"
      confirmButtonColor="#333"
    >
      <div class="dialog-cont">
        <img src="../img/ok.png" />
        <p>恭喜您，已经成为代理人</p>
      </div>
    </van-dialog>

    <van-dialog v-model="show2" confirmButtonText="确认" confirmButtonColor="#333">
      <div class="dialog-cont">
        <p style="padding-top: 0.64rem;font-size: 0.28rem">{{ erro }}</p>
      </div>
    </van-dialog>

    <van-dialog v-model="show3" confirmButtonText="招募代理人" confirmButtonColor="#333">
      <div class="dialog-cont">
        <p
          style="padding-top: 0.64rem;font-size: 0.32rem;padding-left: 0.48rem;padding-right: 0.28rem"
        >
          <span style="color: #DD2B1E;font-size: 0.32rem">{{ user.mobile }}</span> 您已经是代理人了赶快去招募下级吧
        </p>
      </div>
    </van-dialog>

    <van-dialog
      v-model="show4"
      confirmButtonText="确认"
      @cancel="show4=false"
      @confirm="joinCommunity()"
      :showCancelButton="true"
      cancelButtonColor="#666666"
      confirmButtonColor="#333"
    >
      <div class="dialog-cont">
        <div style="text-align: left;padding-left: 0.46rem">
          <p
            style="margin-bottom: 0.24rem;display: flex;align-items: center;justify-content: left;padding-top: 0.4rem;padding-bottom: 0"
          >
            <img
              src="../img/biao.png"
              style="width: 0.4rem;height: 0.4rem;;margin-right: 0.1rem;padding: 0"
              alt
            />
            <span style="font-size: 0.36rem;color: #3A3A3A;font-weight: bold">确定要成为代理人吗？</span>
          </p>

          <p style="padding-bottom: 0.05rem;font-size: 0.32rem">
            手机号：
            <span style="color: #DD2B1E;font-size: 0.32rem">{{ user.mobile }}</span>
          </p>
          <p style="font-size: 0.32rem">社群名称：{{ name }}</p>
        </div>
      </div>
    </van-dialog>
    <footer-body></footer-body>
  </div>
</template>

<script>
import footerBody from "../../common/footer/footer";
import html2canvas from "html2canvas";
import wxShare from "@/libs/wxShare";

export default {
  name: "recruitHome",
  data() {
    return {
      items: [],
      user: null,
      dataUrl: null,
      img: null,
      yindao: false,
      img1: require("../img/timg-21@2x.png"),
      q: {
        type: "2",
        sort: 0,
        page: "1",
        limit: "10"
      },
      shareMemberId: "0",
      communityId: "0",
      show: false,
      erro: "",
      show2: false,
      show3: false,
      show4: false,
      name: "",
      timeOutEvent: 0,
      imageShow: false,
      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    };
  },

  computed: {},
  components: {
    footerBody
  },
  filters: {},
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    if (this.$route.query.communityId)
      this.communityId = this.$route.query.communityId;
    if (this.$route.query.shareMemberId)
      this.shareMemberId = this.$route.query.shareMemberId;
// console.log(this.shareMemberId )
      // alert(this.shareMemberId )
    if (this.user.isAgent === "0") {
      document.title = "加入药联健康大使";
      if (this.communityId != "0" && this.user.isAgent === "0") {
        this.comity();
      }
      this.goods();
    } else {
      if (
        (this.communityId != "0" || this.shareMemberId != "0") &&
        this.user.isAgent === "1"
      ) {
        this.show3 = true;
      }
      this.getBase64Image(this.user.codeUrl, "coopCachetImg", "img");
      wxShare();
      document.title = "邀请药联健康大使";
      // setTimeout(() => {
      //   this.$nextTick().then(() => {
      //     this.get_img();
      //   });
      // }, 1000);
      this.recruitTrackFn();
    }
  },
   mounted() {
    setTimeout(() =>{
        this.get_img();
    },1000);
 },
  methods: {
    setShare(type, sharBigImg) {
      this.$api.invitation({}).then(res => {
        const configData = res.data;
        
        let shareDate = {
          shareLink: configData.shareUrl,
          shareTitle: configData.title,
          shareDescr: "分享描述",
          shareImg: configData.picUrl,
          shareType: type,
          shareBigImg: sharBigImg || 0
        };
        // console.log('sharedata',shareDate)
        this.$bs.wxShare(shareDate).then(e => {
          // console.log('eee',e)
          if (e.status == "1") {
            this.$toast("分享成功");
          } else if (e.msg) {
            this.$toast(e.msg);
          }
        });
      });
    },
    toSave() {
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "recruit",
        card_type: "scan",
        card_position: 1,
        material_type: "keep_bnt",
        material_position: 1
      });
    },
    toYindao() {
       console.log('111000',this.user)
      // console.log("this.$store.state.data.state", this.$store.state.data.state);
      if (this.$store.state.data.state === "ydb") {
        // console.log('into ydb')
        this.setShare(1);
      }
       if(this.user.channelType == 'app'){
        this.$api.invitation({}).then(res => {
          const configData = res.data;
          let sharObj = { 
          shareLink: configData.shareUrl,
          shareTitle: configData.title,
          shareDescr: "分享描述",
          shareImg: configData.picUrl,
          shareType:"1"
        }
        UnionDrugHealthy.gotoShare(JSON.stringify(sharObj))
        });
    } 
    if(this.user.channelType == 'wechat') {
        this.yindao = true;
      }
      // this.setShare(1);

      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "recruit",
        card_type: "invite",
        card_position: 1,
        material_type: "invite_bnt",
        material_position: 1
      });
    },
    recruitTrackFn() {
      this.$nextTick(() => {
        this.$trackFn.load("yaoqing-btn", "view_material", {
          // 曝光 - 埋点
          page_type: "recruit",
          card_type: "invite",
          card_position: 1,
          material_type: "invite_bnt",
          material_position: 1
        });
        this.$trackFn.load("btn", "view_material", {
          // 曝光 - 埋点
          page_type: "recruit",
          card_type: "scan",
          card_position: 1,
          material_type: "keep_bnt",
          material_position: 1
        });
      });

      let time1 = new Date().getTime();
      window.onbeforeunload = e => {
        let time2 = new Date().getTime();
        let dateDiff = (time2 - time1) / 1000;
        let page_type = "recruit";
        this.$trackFn.view("$pageview", {
          page_type: page_type,
          event_duration: dateDiff
        }); // 招募页 ——浏览埋点
        sessionStorage.setItem("pageType", page_type);
        // return "关闭提示";
      };
    },
    jumpUrl(jumpUrl) {
      window.location.href = jumpUrl;
    },
    goods() {
      this.$api.goodsPaging(this.q).then(res => {
        this.items = res.data.body;
        this.recruitTrackFn();
      });
    },
    joinCommunity() {
      this.$api
        .joinCommunity({
          communityId: this.communityId,
          shareMemberId: this.shareMemberId
        })
        .then(res => {
          this.show4 = false;
          if (res.errno === "802") {
            this.$router.push("/fail?fail=" + res.error);
          } else if (res.errno === "0" || res.errno === "801") {
            this.getBase64Image(this.user.codeUrl, "coopCachetImg", "img");
            wxShare();
            this.show = true;
            this.user.isAgent = "1";
            sessionStorage.setItem("user", JSON.stringify(this.user));
          } else {
            this.show2 = true;
            this.erro = res.error;
          }
        });
    },

    comity() {
      this.$api
        .communityInfo({
          id: this.communityId
        })
        .then(res => {
          this.name = res.data.name;
          this.show4 = true;
        });
    },

    urlFnT() {
      window.location.href = "/distribution/goodsHome";
    },
    saveImage() {
      this.$bs.downImage({ base64: this.dataUrl }).then(e => {
        if (e.msg) {
          this.$toast(e.msg);
        }
      });
      this.imageShow = false;
    },
    cancelSaveImage(){
      this.imageShow = false;
    },
    //长按保存图片
    touchstart() {
      if (sessionStorage.getItem("state") == "ydb" && !this.isiOS) {
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(() => {
          this.imageShow = true;
        }, 700);
      }
    },
    //清除定时器
    touchend() {
      clearInterval(this.Loop);
    },
    get_img() {
      var content_html = document.getElementById("bg"); //要转化的div
      // var scrollTop =
      //   document.documentElement.scrollTop || document.body.scrollTop; // 获取页面滚动高度
      // var opts = {
      //   allowTaint: false,
      //   useCORS: true,
      //   height: content_html.offsetHeight - 10,
      //   width: content_html.offsetWidth,
      //   windowWidth: document.body.scrollWidth,
      //   windowHeight: document.body.scrollHeight,
      //   x: 0,
      //   y: scrollTop, // 用网页滚动的高度定位y轴顶点
      //   dpi: window.devicePixelRatio * 2,
      //   scale: 2
      // };
      // setTimeout(() => {
      //   html2canvas(this.$refs.bg, opts)
      //     .then(canvas => {
      //       this.dataUrl = canvas.toDataURL();
      //     })
      //     .catch(err => {
      //       console.log(1321321312, err);
      //     });
      // }, 500);

//       let myBox = this.$refs.bgImg;
// html2canvas(myBox, {
//         useCORS: true,
//         width: content_html.offsetWidth,
//         height: content_html.offsetHeight,
//         windowWidth: document.body.scrollWidth,
//         windowHeight: document.body.scrollHeight,
//         x:0,
//         y:window.pageYOffset
//       }).then(canvas => {
//         let data = canvas.toDataURL();
//         console.log('图片',data)
//         this.dataUrl = data
//       });
    if(this.isiOS){
    var opts = {
        useCORS: true,
            width: content_html.offsetWidth,
            height: content_html.offsetHeight,
            windowWidth: document.body.scrollWidth,
            windowHeight: document.body.scrollHeight,
            x:0,
            y:window.pageYOffset
      }
    }else{
      var opts = {
        useCORS: true,
            width: window.screen.availWidth,
            height: window.screen.availHeight,
            windowWidth: document.body.scrollWidth,
            windowHeight: document.body.scrollHeight,
            x:0,
            y:window.pageYOffset
      }
    }

    let myBox = this.$refs.saveBox;
          html2canvas(myBox, opts).then(canvas => {
            let data = canvas.toDataURL();
            console.log(data)
            this.dataUrl = data
          });
    },
    getPixelRatio(context) {
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1;
      return (window.devicePixelRatio || 1) / backingStore;
    },

    //  第一个参数是图片的URL地址，第二个是转换成base64地址后要赋值给的img标签
    getBase64Image(url, ref, name) {
      var that = this;
      var image = new Image();
      image.crossOrigin = "*"; // 支持跨域图片
      image.src = url + "?v=" + Math.random(); // 处理缓存
      image.onload = function() {
        that.drawBase64Image(image);
      };
    },
    drawBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var dataURL = canvas.toDataURL("image/png");
      this.img = dataURL;
    },
    guizeFn() {
      this.$router.push("/guize");
    }
  }
};
</script>

<style lang="scss" scoped>
.jinsheng {
  background-image: url("../img/zhaomu.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-flow: column;
  align-items: center;
  .img-one {
    width: 240px;
    margin-bottom: 20px;
  }
  .img-two {
    width: 650px;
    margin-bottom: 36px;
  }
  .img-three {
    width: 650px;
    margin-bottom: 58px;
  }
  .img-btn {
    width: 420px;
    margin-bottom: 80px;
  }
}

.youjiang {
  background-image: url("../img/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .img-box {
    display: flex;
    flex-flow: column;
    align-items: center;

    .img-one {
      width: 240px;
      margin-bottom: 20px;
    }

    .img-two {
      width: 640px;
      margin-bottom: 45px;
    }

    .img-three {
      width: 100%;
    }

    .yaoqing-box {
      width: 700px;

      .yaoqing-btn {
        margin: 120px auto 80px auto;
        width: 420px;

        img {
          width: 100%;
        }
      }

      .yaoqing-txt {
        display: flex;
        justify-content: center;
        margin-top: -500px;
      }

      .txt {
        text-align: center;
        width: 250px;
        font-size: 28px;
        color: #dd2b1e;
        background-color: rgba(250, 196, 142, 0.5);
        padding: 8px 0;
        border-radius: 30px;
        margin: 0 30px 0 30px;
      }

      .border {
        margin-top: 20px;
        width: 216px;
        height: 0;
        border-top: 4px dashed #dd2b1e;
      }
    }
  }
}

.guize {
  width: 40px;
  background: rgba(173, 12, 0, 1);
  border-radius: 8px 0 0 8px;
  position: absolute;
  font-size: 26px;
  font-weight: 400;
  color: rgba(255, 241, 223, 1);
  line-height: 28px;
  text-align: center;
  right: 0;
  top: 70px;
  padding: 12px 0;
  z-index: 99999;
}

.cont_x {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border-radius: 30px 30px 0 0;
  position: relative;
  margin-top: 60px;
  padding-top: 58px;
}

.cont_x2x {
  padding-top: 30px;
  margin-top: 20px;
  border-radius: 0;
}

.cont_x img {
  width: 6px;
  height: 32px;
}

.cont_x_fenx {
  display: flex;
  align-items: center;
}

.cont_x_fenx h3 {
  font-size: 32px;
  font-weight: 500;
  color: rgba(64, 64, 64, 1);
  margin-left: 30px;
  margin-right: 20px;
}

.cont_x_fenx p {
  font-size: 24px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}

.list {
  display: flex;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
}

.cont_x1 img {
  width: 6px;
  height: 32px;
}

#bg {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: -2;
  overflow: hidden;
}
#bg div {
  position: relative;
}
.bg_img {
  position: absolute;
  bottom: 6.6%;
  left: 50%;
  width: 26%;
  margin-left: -13%;
  border-radius: 0.1rem;
}

.btn {
  width: 420px;
  height: 90px;
  background: rgba(221, 43, 30, 1);
  border-radius: 45px;
  position: relative;
  margin: 0 auto 200px auto;
  font-size: 32px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}

.dataUrl {
  width: 100%;
  height: 4rem;
  opacity: 0;
  position: absolute;
  left: 0;
  bottom: 0;
}

.yingdao {
  position: fixed;
  z-index: 9999999;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  text-align: right;
  padding-top: 26px;
}

.yingdao img {
  width: 560px;
  height: 312px;
  margin-right: 36px;
}

.contx {
  overflow: hidden;
  width: 100%;
  padding: 0 30px;
}

.good_list_img {
  width: 28px !important;
  height: 28px !important;
}

.contx .list {
  width: calc(50% - 15px);
  float: left;
  margin-bottom: 5px;
  overflow: hidden;
  display: block;
  padding: 0;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
}

.contx.kong1 {
  padding-top: 188px;
  text-align: center;
}

.contx .kong1 img {
  width: 270px;
}

.contx .kong1 p {
  font-size: 24px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 34px;
}

.contx .list:nth-child(odd) {
  margin-right: 30px;
}

.contx .list:nth-child(even) {
  margin-right: 0;
}

.contx .good_list {
  width: 100%;
  height: 280px;
  display: block;
}

.contx .goods_text_p {
  text-align: justify;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  font-size: 28px;
  color: #404040;
  -webkit-box-orient: vertical;
  height: 84px;
}

.contx .goods_text_cont_x {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.contx .goods_text_cont {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.contx .goods_text {
  display: flex;
  align-items: center;
}

.contx .goods_text_left {
  color: #dd2b1e;
  font-size: 24px;
  align-items: baseline;
}

.contx .goods_text_right {
  color: #ffa72e;
  background: rgba(255, 167, 46, 0.09);
  border-radius: 30px;
  height: 28px;
  justify-content: left;
  position: relative;
  top: 3px;
  padding: 4px 8px;
}
.goods_text_right img {
  width: 28px;
  height: 28px;
}

.contx .goods_text_left span {
  font-size: 36px;
}

.contx .mer {
  width: 100%;
  height: 170px;
  margin: auto;
}

.contx_cont {
  display: flex;
  padding: 0 42px;
}

.contx_list_fwu {
  width: 33.33%;
  text-align: center;
}

.contx_list_fwu:first-child {
  text-align: left;
}

.contx_list_fwu:last-child {
  text-align: right;
}

.contx_list_fwu img {
  width: 108px;
  height: 108px;
}

.contx_list_fwu p {
  font-size: 28px;
  font-weight: 400;
  color: rgba(100, 100, 100, 1);
  line-height: 40px;
}

.dialog-cont {
  text-align: center;
}

.dialog-cont img {
  padding-top: 40px;
  width: 112px;
  padding-bottom: 44px;
}

.dialog-cont p {
  font-size: 36px;
  font-weight: 400;
  color: rgba(76, 76, 76, 1);
  line-height: 52px;
  padding-bottom: 64px;
}

.cont_x_2 {
  margin-top: -40px;
}
.van-popup--bottom {
  z-index: 10000000000 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.van-popup{
  background-color: transparent;
}
.van-button{
  width: 90%;
  margin-bottom: 10px;
  border-radius: 10px;
  height: 52px;
}
.van-button--default{
  color: #007AFF;
}
.van-button--normal{
  font-size: 20px;
}
</style>
